import { gql } from "apollo-angular";
import { CBF } from "./content-block";

export const  CBFF = gql`
  fragment CBFF on ContentBlock {
    backgroundColor {
      color
    }
    sys {
      id
    }
    isPzd
    ... CBF  
}
${CBF}`;
